import { useMutation } from '@apollo/client';
import { graphql } from 'gql.tada';

const AddStudentToClassMutation = graphql.persisted(
  "AddStudentToClass",
  graphql(`
    mutation AddStudentToClass($input: AddStudentToClassInput!) {
      addStudentToClass(input: $input) {
        rosterEntry { id }
        userErrors { message path }
      }
    }
  `)
);

const RemoveStudentFromClassMutation = graphql.persisted(
  "RemoveStudentFromClass",
  graphql(`
    mutation RemoveStudentFromClass($input: RemoveStudentFromClassInput!) {
      removeStudentFromClass(input: $input) {
        rosterEntry { id state }
        userErrors { message path }
      }
    }
  `)
);

const BulkAddStudentsToClassMutation = graphql.persisted(
  "BulkAddStudentsToClass",
  graphql(`
    mutation BulkAddStudentsToClass($input: BulkAddStudentsToClassInput!) {
      bulkAddStudentsToClass(input: $input) {
        addedCount
        userErrors { message path }
      }
    }
  `)
);

const AssignInstructorMutation = graphql.persisted(
  "AssignInstructor",
  graphql(`
    mutation AssignInstructor($input: AssignInstructorInput!) {
      assignInstructor(input: $input) {
        instructor { id role }
        userErrors { message path }
      }
    }
  `)
);

const RemoveInstructorMutation = graphql.persisted(
  "RemoveInstructor",
  graphql(`
    mutation RemoveInstructor($input: RemoveInstructorInput!) {
      removeInstructor(input: $input) {
        success
        userErrors { message path }
      }
    }
  `)
);

export { AddStudentToClassMutation, RemoveStudentFromClassMutation, BulkAddStudentsToClassMutation, AssignInstructorMutation, RemoveInstructorMutation };

export function useAddStudentToClass() { return useMutation(AddStudentToClassMutation); }
export function useRemoveStudentFromClass() { return useMutation(RemoveStudentFromClassMutation); }
export function useBulkAddStudentsToClass() { return useMutation(BulkAddStudentsToClassMutation); }
export function useAssignInstructor() { return useMutation(AssignInstructorMutation); }
export function useRemoveInstructor() { return useMutation(RemoveInstructorMutation); }
